module.exports = __webpack_public_path__ + "img/dxctj_lt.f3dadd23.jpg";